module.exports = __webpack_public_path__ + "static/img/smaco-10.267ba00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg/smaco-10.jpg
// module id = 0QWg
// module chunks = 1